function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isServer, isValidTimeout } from "./utils.mjs";
export var Removable = /*#__PURE__*/function () {
  function Removable() {
    _classCallCheck(this, Removable);
  }

  _createClass(Removable, [{
    key: "destroy",
    value: function destroy() {
      this.clearGcTimeout();
    }
  }, {
    key: "scheduleGc",
    value: function scheduleGc() {
      var _this = this;

      this.clearGcTimeout();

      if (isValidTimeout(this.cacheTime)) {
        this.gcTimeout = setTimeout(function () {
          _this.optionalRemove();
        }, this.cacheTime);
      }
    }
  }, {
    key: "updateCacheTime",
    value: function updateCacheTime(newCacheTime) {
      // Default to 5 minutes (Infinity for server-side) if no cache time is set
      this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : isServer ? Infinity : 5 * 60 * 1000);
    }
  }, {
    key: "clearGcTimeout",
    value: function clearGcTimeout() {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }]);

  return Removable;
}();